import React, { useEffect, useState } from 'react';
import VerificationPopup from './modals/VerificationPopup';
import styles from '../styles/newFeature.module.css';
import content from '../language/ENGLISH.json'
import { HeroSection, MarqueeComponentHomePage, StackContainers, StackSkeleton } from './qbStrap';
import { ClientsArr1, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import FAQ_mobile from './Industry/FAQ_mobile';
import FrequentQuestions from './homePage/FrequentQuestions';
import MobilePDBanner from './common/MobilePDBanner';
import PersonalisedDemoBanner from './common/PersonalisedDemoBanner';
import TestimonialSection from './common/TestimonialSection';
import MobileTestimonialSection from './common/MobileTestimonialSection';
import ThreeStepForm from './common/ThreeStepForm';
import Image from 'next/image';
import OutletFeatures from './common/OutletFeatures';
import { useRouter } from 'next/router';
import NewTestimonial from './newVideoTestimonial/NewTestimonial';
// import NewTestimonial from './DemoFinal/NewTestimonial';

const TemplePOS = () => {
    const { commonMarqueTitle } = getTitleContent();
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const [heroReadMore, setHeroReadMore] = useState(false);
    const router = useRouter()

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const features = [
        {
            id: 1,
            image: "/assets/templePOS/templePosImage.webp",
            tag: "Pooja Booking Management",
            icon: "/assets/groceries/kirana/booking.svg",
            title: "Hassle-Free Pooja Booking Management",
            desc: "This feature takes away the headache of manual bookings for temple administrators, dealing with a smooth glimpse of upcoming rituals. It also sends automated communications to devotees and the temple management team, which provides ample time for preparation.",
            tagColor: "#8AE4F6",
            bgColor: "#8ae4f626",
            stackColor1: "#D6F6FC",
            stackColor2: "#B0EFFC",
            stackColor3: "#8AE4F6",
            stackColor4: "#70D3E6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "10rem",
            meHeight: "28rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Book Poojas hassle-free anywhere for devotees.
                </>,
                <>
                    Give instant receipt - digital or physical.
                </>,
                <>
                    Optimize Temple Operations with efficient booking management.
                </>,
            ],
        },
        {
            id: 2,
            image: "/assets/templePOS/inventoryTemple.webp",
            tag: "Temple Management",
            icon: "/assets/outlet/iceCreamOutlet/templemanagement.svg",
            title: "Streamline Your Temple's Daily Operations with Ease",
            desc: "Be it a temple, a church, a mosque or any other religious entity, use Temple POS software for scheduling events, congregations, satsangs and also for tracking visitor stats. It can support activities and tasks in execution at their scheduled times. To add on, it is included in customizable modules to fulfill specific requirements in the process, thus allowing the different temple authorities to serve the community best.",
            tagColor: "#FFBA00",
            bgColor: "#fff7e2",
            stackColor1: "#FEF8EB",
            stackColor2: "#FEEAC0",
            stackColor3: "#FFD579",
            stackColor4: "#FFC23E",
            sHeight: "10rem",
            eHeight: "26rem",
            msHeight: "15rem",
            meHeight: "41rem",
            btnText: "Contact Sales",
            points: [
                <>
                    All temple processes are centralized for easy management.
                </>,
                <>
                    The software is highly customizable to meet the specific needs of any temple.
                </>,
                <>
                    Efficient tools for administration, easy community service with the best POS solution.
                </>,
            ],
        },
        {
            id: 3,
            image: "/assets/templePOS/vendorTemple.webp" ,
            tag: "Donation Management",
            icon: "/assets/outlet/iceCreamOutlet/donation.svg",
            title: "Donor Engagement with Seamless Tracking and Automated Acknowledgments",
            desc: "The Donation Management feature makes the handling of temple donations an easy affair. The system records the donations in real time, indicating donor trends and accounting for all funds expended. Support for different payment options makes it easy for devotees to contribute online or in person. The feature can also issue receipts and thank-you notes, creating a closer link between the temple and its patrons.",
            tagColor: "#EEC9FF",
            bgColor: "#fcf6ff",
            stackColor1: "#FCF7FF",
            stackColor2: "#F4E1FF",
            stackColor3: "#EEC9FF",
            stackColor4: "#E4ADFE",
            sHeight: "10rem",
            eHeight: "29rem",
            msHeight: "17rem",
            meHeight: "45rem",
            btnText: "Talk  to an expert",
            points: [
                <>
                    Real-time tracking and management of donations for transparency.
                </>,
                <>
                    Provide easy contributions with multiple payment options.
                </>,
                <>
                    Build relationships by sending out custom receipts and notes.
                </>,
            ],
        },
        {
            id: 4,
            image: "/assets/templePOS/inventory.webp",
            tag: "Inventory Management",
            icon: "/assets/outlet/iceCreamOutlet/inventry.svg",
            title: "Seamless Stock Management for Essential Temple Supplies",
            desc: "This makes the inventory management feature a significant tool for the temples since it deals with stocks of varied items such as prasad, flowers, pooja materials, and temple merchandise. The real-time stock level maintained ensures that the temple always has stocks of these essential items. Moreover, it simplifies ordering and replenishment, ensuring that no shortage can hamper temple activities.",
            tagColor: "#4EEAC2",
            bgColor: "#e6fff9",
            stackColor1: "#C8F4E9",
            stackColor2: "#9EE9D6",
            stackColor3: "#4EEAC2",
            stackColor4: "#47DDB6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Realtime product levels availability and hence on schedule.
                </>,
                <>
                    Enhanced reordering and restocking in a streamlined manner for the smooth functioning of temple activities.
                </>,
                <>
                    Ensure proper inventory report detailing for denoting wastage and optimizing costs.
                </>,
            ],
        },
        {
            id: 5,
            image: "/assets/templePOS/online-ticket-booking.webp",
            tag: "Online Ticket Booking",
            icon: "/assets/outlet/iceCreamOutlet/onlineticket.svg",
            title: "Hassle-Free Ticket Booking for Events, Darshan and Satsangs",
            desc: "The Online Ticket Booking facility would assist devotees in booking tickets for any function or event, special darshan, or festival being held at the temple. With this system, the devotees can easily choose from available slots and pay online in a secure fashion. This information will paint a vivid picture of the management of the temple regarding ticket sales and attending individuals, thus effectively controlling the crowd and better planning for events.",
            tagColor: "#FFC3C3",
            bgColor: "#FFF3F3",
            stackColor1: "#FFF3F3",
            stackColor2: "#FFEBEB",
            stackColor3: "#FFDBDB",
            stackColor4: "#FFC3C3",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                     Book tickets and slots for events or satsangs.
                </>,
                <>
                    Real-time information on ticket sales.
                </>,
                <>
                    Automated sales for easy event planning.
                </>,
            ],
        },
        // {
        //     id: 6,
        //     image: "/assets/templePOS/parkingTemple.webp",
        //     tag: "Parking Management",
        //     icon: "/assets/groceries/kirana/parking.svg",
        //     title: "Real-Time Slot Updates for Stress-Free Parking",
        //     desc: "Parking is a big issue at temple events, but it gets managed properly through QueueBuster's Temple POS Solution—making it possible for worshippers to pre-book parking spots and easily visit the temple. Realtime updates in the solution provide information on parking slot availability, avoiding overcrowding and reducing waiting times. As far as temple authorities are concerned, it gives them an all-inclusive view of parking operations for an enhanced visitor experience.",
        //     tagColor: "#8AE4F6",
        //     bgColor: "#8ae4f626",
        //     stackColor1: "#D6F6FC",
        //     stackColor2: "#B0EFFC",
        //     stackColor3: "#8AE4F6",
        //     stackColor4: "#70D3E6",
        //     sHeight: "7rem",
        //     eHeight: "20rem",
        //     msHeight: "10rem",
        //     meHeight: "28rem",
        //     btnText: "Contact Sales",
        //     points: [
        //         <>
        //             Ensure stress-free temple visits by pre-booking parking spots.
        //         </>,
        //         <>
        //             Keep your visitors up-to-date with real-time parking availability information.
        //         </>,
        //         <>
        //             Ensure visitor satisfaction by optimizing the parking experience.
        //         </>,
        //     ],
        // },
    ];

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is QueueBuster Temple POS Solution, and how does it benefit religious centers and nonprofit organizations?
                </span>
            ),
            des:  (
                <>
                <p>The QueueBuster Temple POS Solution is a comprehensive, user-friendly platform specifically designed for religious centers and nonprofit organizations. It simplifies financial management tasks such as processing donations, offerings, and merchandise sales, while also integrating multiple other essential operations into a single platform. By offering multiple payment options, the system ensures secure, quick transactions and provides detailed reporting for transparent financial management. This increased transparency not only builds trust among devotees and donors but also helps the temple or organization to maintain accurate financial records, comply with regulatory requirements, and optimize resource allocation.</p>
                <p>Moreover, the QueueBuster Temple POS Solution is customizable to meet the unique needs of each organization. It streamlines operations such as Pooja bookings, event scheduling, inventory management, and more, allowing temple authorities to focus on community service and spiritual activities rather than administrative burdens. The system's automation features further reduce manual workload, leading to more efficient operations and enhanced service delivery for devotees.</p>
                 </>
                
            ),
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the Online Pooja Booking feature work, and what advantages does it offer to both devotees and temple management?
                </span>
            ),
            des: (
                <>
                <p>The Online Pooja Booking feature of the QueueBuster Temple POS Solution is designed to make the process of booking Poojas simple and convenient for devotees. Devotees can book Poojas from anywhere at any time using their mobile devices or computers. They can select specific dates, times, and even the type of Pooja they wish to perform, all through an intuitive online interface. This feature eliminates the need for devotees to physically visit the temple or make phone calls to book their Poojas, making the process more accessible and user-friendly.</p>
                <p>For temple management, this feature offers significant operational benefits. It automates the booking process, reducing the administrative burden of handling manual bookings and ensuring that no details are overlooked. The system also sends automated notifications to both devotees and temple staff, ensuring that everyone is well prepared for the upcoming rituals. This leads to better planning and execution of Poojas, enhances the overall experience for devotees, and allows temple authorities to manage their schedules more efficiently.</p>
                </>
            ),
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What makes the Temple Management feature of the QueueBuster POS Solution unique, and how does it improve the day-to-day operations of a temple?
                </span>
            ),
            des: "The Temple Management feature of the QueueBuster POS Solution stands out for its ability to centralize all temple operations into a single, easy-to-use platform. This feature is designed to streamline the administrative tasks involved in running a temple, such as scheduling events, managing staff, and tracking visitor statistics. By bringing these functions together, the system ensures that all activities are coordinated and executed smoothly. One of the key benefits of this feature is its flexibility. The Temple Management system includes customizable modules that can be tailored to the specific needs of any temple. Whether the temple is large or small, this system can be adapted to handle its unique requirements, such as managing different types of events, coordinating with various departments, and serving the community more effectively. The centralized platform also makes it easier for temple authorities to monitor and manage all operations, leading to improved efficiency, better resource allocation, and enhanced service delivery.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the Donation Management feature enhance transparency and accountability in temple finances?
                </span>
            ),
            des: (
                <>
                <p>The Donation Management feature of the QueueBuster Temple POS Solution is specifically designed to enhance transparency and accountability in temple finances. It allows for real-time tracking and recording of all donations, whether they are made online or in person. This feature ensures that every donation is accounted for, reducing the risk of errors or discrepancies in financial records. Additionally, the system provides detailed reports on donation trends, enabling temple authorities to analyze donor behavior and identify patterns. This information can be used to improve fundraising strategies, engage with donors more effectively, and ensure that funds are being utilized in the most impactful way. The system also supports multiple payment options, making it easier for devotees to contribute in a manner that suits them best.</p>
                <p>Moreover, the Donation Management feature can issue receipts and thank-you notes automatically, fostering stronger relationships between the temple and its patrons. By providing donors with clear and transparent records of their contributions, the system helps to build trust and encourages continued support for the temple's activities.</p>
                </>
            ),
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the Inventory Management feature help temples manage their resources more effectively?
                </span>
            ),
            des: "The Inventory Management feature of the QueueBuster Temple POS Solution is an essential tool for temples that handle a variety of items, such as prasad, flowers, Pooja materials, and merchandise. This feature provides real-time tracking of stock levels, ensuring that the temple always has the necessary items available for its activities. By monitoring inventory in real time, the system helps to prevent shortages that could disrupt temple operations, such as running out of Pooja materials during a busy period.The system also simplifies the process of ordering and replenishing stock. It can automatically generate orders when inventory levels fall below a certain threshold, ensuring that supplies are restocked promptly. This reduces the administrative burden on temple staff and allows them to focus on more important tasks. Detailed reporting capabilities provide temple authorities with insights into inventory levels, usage patterns, and wastage, enabling them to optimize resource allocation and reduce costs.Overall, the Inventory Management feature helps temples to manage their resources more efficiently, ensuring that essential items are always available while minimizing waste and controlling expenses.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What are the benefits of using the Online Ticket Booking feature for temple events and festivals?
                </span>
            ),
            des: "The Online Ticket Booking feature of the QueueBuster Temple POS Solution offers numerous benefits for both devotees and temple management when it comes to organizing events and festivals. For devotees, this feature provides a convenient and secure way to book tickets for special darshans, festivals, and other temple events. They can select from available time slots, make payments online, and receive instant confirmation, all from the comfort of their homes.For temple management, this feature significantly reduces the administrative workload associated with event planning. It provides real-time data on ticket sales and attendance, allowing temple authorities to better plan and manage events. This information can be used to control crowds, allocate resources more effectively, and ensure that all attendees have a positive experience. The system also automates many aspects of the ticketing process, such as generating and sending tickets, which further reduces the burden on temple staff. By streamlining ticket sales and event management, the Online Ticket Booking feature helps to enhance the overall efficiency of temple operations and improve the experience for devotees.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                     How does the Parking Management feature improve the visitor experience at temple events?
                </span>
            ),
            des: "Parking is often a significant challenge during temple events, especially when large crowds are expected. The Parking Management feature of the QueueBuster Temple POS Solution addresses this issue by allowing devotees to pre-book parking spots before they arrive at the temple. This feature helps to ensure that parking is organized and efficient, reducing the stress and frustration that often accompany finding a parking space during busy events. For temple management, this feature provides real-time updates on parking availability, allowing them to manage parking resources more effectively. It helps to prevent overcrowding in the parking areas, reduces wait times, and ensures that visitors can park their vehicles quickly and easily. This contributes to a smoother overall experience for devotees, making their visit to the temple more enjoyable. The Parking Management feature also provides temple authorities with a comprehensive view of parking operations, enabling them to monitor and optimize the use of parking spaces. This not only improves the visitor experience but also enhances the overall efficiency of temple operations during events.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster Temple POS ensure the security of financial transactions?
                </span>
            ),
            des: "Security is a top priority for the QueueBuster Temple POS Solution, especially when it comes to handling financial transactions. The system is designed with advanced security features to protect sensitive financial data and ensure that all transactions are processed securely. It uses encryption technology to safeguard payment information, making it difficult for unauthorized parties to access or tamper with the data. In addition to encryption, the system supports multiple authentication methods to verify the identity of users before they can access or process transactions. This helps to prevent fraud and unauthorized access to the system. The POS system also complies with industry-standard security protocols, ensuring that it meets the highest standards for data protection. For temple authorities, the system provides detailed logs and audit trails of all financial transactions, enabling them to monitor and review transactions for any suspicious activity. By offering a secure and transparent platform for financial management, the QueueBuster Temple POS Solution helps to build trust among devotees and ensures that temple finances are managed with the highest level of integrity.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can the QueueBuster Temple POS Solution be customized to meet the specific needs of different temples?
                </span>
            ),
            des: "Yes, the QueueBuster Temple POS Solution is highly customizable and can be tailored to meet the specific needs of different temples and religious organizations. The system is designed with flexibility in mind, allowing temple authorities to choose the features and modules that best suit their requirements. Whether a temple needs to focus on managing donations, scheduling events, handling inventory, or any other specific function, the QueueBuster Temple POS Solution can be configured to accommodate those needs. Customization options include the ability to modify the user interface, integrate with other systems or software, and create custom reports and dashboards. This ensures that the system aligns with the temple's unique operational workflows and administrative processes. Additionally, the QueueBuster team provides support and consultation services to help temples implement and customize the system according to their specific goals and objectives.",
            id: 9,
            activeIndex: 0,
        },
        // {
        //     para: (
        //         <span style={{ width: "90%" }}>
        //             What financial management features does QueueBuster’s WMS include?
        //         </span>
        //     ),
        //     des: "Our system includes a comprehensive accounting and financial management module that supports a wide range of financial activities. Key features include journal entries, cash/bank vouchers, bills receivables/payables, cost centers, balance sheets, P&L, and ratio analysis. The system also offers GST e-filing capabilities, allowing businesses to generate and file GST returns easily. Additional features include the generation of E-Way bills, cheque printing, and TDS/TCS management. The module provides a detailed GST summary and auto-entry of GST payable with journal entries, facilitating compliance with tax regulations. These financial management features ensure accurate and efficient handling of all financial transactions, contributing to overall business efficiency.",
        //     id: 10,
        //     activeIndex: 0,
        // },
    ];

    return (
        <div>
            <div className={styles.verificationPopupOverride}>

            <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            {
                mobileView ?
                    <div className={styles.hero_section} style={{ backgroundImage: "url('/assets/templePOS/templeMobileImage.webp')" }}>
                        <div>
                            <h1>
                                <span>POS Billing Software for</span><span></span>
                                <span>&nbsp; Temples and Religious Institutions</span>
                            </h1>
                            <p style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>The QueueBuster Temple POS solution offers an easy-to-use interface designed to simplify temple and religious entities’ day to day operations. It enables efficient and secure processing of various transactions, including donations, darshan or pooja booking, merchandise sales, langar management and more.</p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className={styles.solid_btn} onClick={() => router.push('/contact-form')}>Contact Sales</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            style={{ font: "normal normal bold 4.3rem/5.5rem Inter", color: "#fff" }}
                            backgroundImg="/assets/templePOS/templeImage.webp"
                            heading={<>POS Billing Software for  </>}
                            staticHeading={<>Temples and Religious Institutions</>}
                            description={"The QueueBuster Temple POS solution offers an easy-to-use interface designed to simplify temple and religious entities’ day to day operations. It enables efficient and secure processing of various transactions, including donations, darshan or pooja booking, merchandise sales, langar management and more."}
                            solidBtnText={"Contact Sales"}
                            textContainerStyle={{ width: "63%" }}
                            setDemoModal={setDemoModal}
                        />
                    </div>
            }

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.features_section}>
                <div className={styles.section_heading}><h3>Automated and Integrated QB Temple POS</h3><div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
                <OutletFeatures features={features} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={Boolean(mobileView)} />
            </div>

            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>
            {/* <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                <NewTestimonial/>
            </div> */}

            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ?
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"FAQs for Temple POS Solution"} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={"FAQs for Temple POS Solution"} />
                }
            </div>

            <div className={styles.demo_banner_section}>
                {
                    mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
                }
            </div>
        </div>
    )
}

export default TemplePOS